import { createActions } from 'redux-actions';

export const { setNextOverviewStep, setCurrentOverviewStep } = createActions({
  SET_NEXT_OVERVIEW_STEP: overviewStep => ({ overviewStep }),
  SET_CURRENT_OVERVIEW_STEP: currentStep => ({ currentStep }),
});



// WEBPACK FOOTER //
// ./src/store/actions/Overview/index.js